module.exports = __webpack_public_path__ + "static/media/rapid-rescue.f143c538.png";